import ConfirmationDialog from '@rio-cloud/rio-uikit/ConfirmationDialog';
import { FormattedMessage } from 'react-intl';

type MaterialTypeChangeConfirmationDialogProps = {
    show: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

export const MaterialTypeChangeConfirmationDialog = ({
    show,
    onCancel,
    onConfirm,
}: MaterialTypeChangeConfirmationDialogProps) => {
    return (
        <ConfirmationDialog
            show={show}
            title={
                <FormattedMessage
                    id='intl-msg:ordercom-cloud-frontend.orders.create-dialog.material-type-change.confirm.title'
                    defaultMessage='Change load type?'
                />
            }
            content={
                <FormattedMessage
                    id='intl-msg:ordercom-cloud-frontend.orders.create-dialog.material-type-change.confirm.content'
                    defaultMessage='If you change the load type of the first material, all following materials will be removed. You can add them again afterwards.'
                />
            }
            cancelButtonText={
                <FormattedMessage
                    id='intl-msg:ordercom-cloud-frontend.orders.create-dialog.material-type-change.confirm.cancel'
                    defaultMessage='Cancel'
                />
            }
            confirmButtonText={
                <FormattedMessage
                    id='intl-msg:ordercom-cloud-frontend.orders.create-dialog.material-type-change.confirm'
                    defaultMessage='Confirm'
                />
            }
            onClickCancel={onCancel}
            onClickConfirm={onConfirm}
        />
    );
};
